import React, { MutableRefObject, useRef } from "react";
import {
    AvatarCardHeader,
    CommentInputContainer,
    HeadlinePostInput,
    HeadlineTeaserAvatar,
    HeadlineTeaserBoxTypography,
} from "./CommentInput.styles";
import { useUserProfile } from "@infrastructure/Persistence/UserProfileState";
import { AvatarOptions } from "../UserAvatar/UserAvatar.types";
import userAvatarChecker from "../../Shared/UserAvatarChecker";
import { Stack } from "@mui/material";
import { UserAvatarFactory } from "../UserAvatar/UserAvatarFactory";
import { ImageSolidIcon } from "@icons/ImageSolidIcon";
import { LinkSolidIcon } from "@icons/LinkSolidIcon";
import {
    CommentFormModeEnum,
    useCommentModalState,
} from "../Modals/CommentFormModal/CommentFormModalOpenState";
import { MediaFilesUploadInput } from "../MediaFilesUploadInput/MediaFilesUploadInput";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";

export function CommentInput({
    openCommentInputModal,
}: {
    openCommentInputModal: (
        modalMode: CommentFormModeEnum,
        focusInput?: boolean,
        inputRef?: MutableRefObject<HTMLInputElement>,
    ) => void;
}) {
    const { uuid, screenName, gender, avatar } = useUserProfile();
    const showProfilePicture = true;
    const avatarOptions: AvatarOptions = {
        uuid: uuid ?? null,
        avatar: showProfilePicture ? avatar : undefined,
        gender,
        fallbackColor: !uuid ? "#596E38" : undefined,
        onError: () => userAvatarChecker(avatar, uuid),
        component: HeadlineTeaserAvatar,
        sx: {
            height: "32px",
            width: "32px",
        },
    };

    const { getConfigs } = useGlobalConfigs();
    const createCommentAddLinkEnabled =
        getConfigs()?.createCommentAddLinkEnabled;

    const { isOpen: commentModalIsOpened } = useCommentModalState();

    const inputFileRef = useRef<HTMLInputElement>(null);

    return (
        <>
            <MediaFilesUploadInput ref={inputFileRef} limit={20} />
            <CommentInputContainer
                sx={{
                    opacity: commentModalIsOpened ? 0 : 1,
                }}
            >
                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    onClick={() => {
                        openCommentInputModal(CommentFormModeEnum.TEXT);
                    }}
                >
                    <Stack direction={"row"} alignItems={"center"} minWidth={0}>
                        <AvatarCardHeader
                            avatar={UserAvatarFactory(avatarOptions)}
                        />
                        <HeadlineTeaserBoxTypography>
                            {uuid
                                ? `Kommentiere als ${screenName} `
                                : "Kommentieren"}
                            …
                        </HeadlineTeaserBoxTypography>
                    </Stack>
                    <Stack direction={"row"}>
                        <HeadlinePostInput
                            onClick={(e) => {
                                e.stopPropagation();
                                inputFileRef.current?.click();
                                openCommentInputModal(
                                    CommentFormModeEnum.DEFAULT,
                                );
                            }}
                        >
                            <ImageSolidIcon
                                color={"var(--community-color-primary-text)"}
                            />
                        </HeadlinePostInput>
                        {createCommentAddLinkEnabled && (
                            <HeadlinePostInput
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openCommentInputModal(
                                        CommentFormModeEnum.LINKOUT,
                                    );
                                }}
                                sx={{ marginLeft: "8px" }}
                            >
                                <LinkSolidIcon
                                    color={
                                        "var(--community-color-primary-text)"
                                    }
                                />
                            </HeadlinePostInput>
                        )}
                    </Stack>
                </Stack>
            </CommentInputContainer>
        </>
    );
}
